export default __webpack_public_path__ + "static/1399-c5a7dd0db7f04821ec84ac526f012dd2.gif";